/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.617 23.924a1 1 0 001.09-.217l14-14a1 1 0 00-1.414-1.413L13 21.586l-6.293-6.293A1.002 1.002 0 005 16.001a1 1 0 00.293.707l7 7a.998.998 0 00.324.216z" _fill="#0B2C62"/>'
  }
})
